import { Utils } from '@kw-shared/common';
import { Observable } from 'rxjs';
import { RemoteTag } from '../../../../models';
import { AdvancedHttpClient } from '../../http/AdvancedHttpClient';
import { WebDataRepository } from '../base/WebDataRepository';
import { ITagRepository } from './ITagRepository';

export class TagRepository extends WebDataRepository<RemoteTag> implements ITagRepository {
  constructor(
    public override httpClient: AdvancedHttpClient,
    private basePath?: string
  ) {
    super(httpClient, Utils.joinPaths(basePath, 'tags'));
  }

  /**
   * Override Update to put to /tags/rfidSync/<id>
   */
  override update(entity: Partial<RemoteTag>): Observable<void> {
    const url = Utils.joinPaths(this.basePath, 'tags/rfidSync', entity.id as string);
    return this.httpClient.put<void>({ url, body: entity });
  }
}
